import { Injectable, inject } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { injectQueryClient } from '@ngneat/query';
import { filter, Subscription } from 'rxjs';
import { MixpanelService } from './mixpanel.service';

const LAST_AUTH_USER_KEY = 'rp_last_auth_user';

@Injectable({
    providedIn: 'root',
})
export class AuthCacheService {
    private authService = inject(AuthService);
    private mixpanelService = inject(MixpanelService);

    private readonly queryClient = injectQueryClient();

    init(): Subscription {
        return this.authService.user$
            .pipe(
                filter(
                    (user): user is { sub: string } =>
                        typeof user?.sub === 'string',
                ),
            )
            .subscribe((user) => {
                const lastUser = localStorage.getItem(LAST_AUTH_USER_KEY);
                const currentUser = user.sub;

                if (lastUser && lastUser !== currentUser) {
                    this.mixpanelService.track({
                        id: currentUser,
                        eventName: 'user_cache_cleared',
                        eventDisplayName: 'User Cache Cleared',
                    });
                    localStorage.setItem(LAST_AUTH_USER_KEY, currentUser);
                    this.queryClient.clear();
                    window.location.reload();
                    return;
                }

                localStorage.setItem(LAST_AUTH_USER_KEY, currentUser);
            });
    }
}
